<template>
    <div id="recordContent">
        <div class="recordContent" :style="{ height: calculatedHeight }">
            <recordBuy v-if="showStatus == 0" :list="list"></recordBuy>
            <recordCover v-if="showStatus == 1" @getTotal="getTotal"></recordCover>
        </div>
        <bottomPage v-if="showStatus == 1 && total" :total="total" @currentNUm="currentNUm"></bottomPage>
    </div>
</template>

<script>
import bottomPage from '../components/bottom_page.vue' //底部分页
import recordBuy from '../components/record_buy.vue' //购买记录
import recordDownload from '../components/record_download.vue' //下载记录
import recordCover from '../components/record_cover.vue' //下载记录
import { EventBus } from '@/utils/eventBus'
import api from '@/api/api';
export default {
    components: {
        bottomPage, recordBuy, recordDownload, recordCover
    },
    data() {
        return {
            showStatus: 0, //0购买记录 1下载记录 3封面记录
            total: null, //总记录
            list:[], //购买记录
        }
    },
    mounted() {
        EventBus.$on('recordI', (i) => {
            this.showStatus = i
            this.getList(i)
        })
    }, 
    computed: {
        calculatedHeight() {
            return this.totle === 0 ? 'calc(100% - 0px)' : 'calc(100% - 90px)';
        }
    },
    created() {
        this.showStatus = JSON.parse(sessionStorage.getItem('recordI'))
        this.getList(this.showStatus)
    },
    methods: {
        getList(i) {
            if (i == 0) {
                this.getBuylist()
            }
        },
        getBuylist() {
            api.getBuylist().then((res) => {
                if (res.code == 200) {
                    this.totle = res.data.count
                    this.list = res.data.orders
                }
            })
        },
        getTotal(item){
            this.total = item
        },
        currentNUm(item){
            EventBus.$emit('coverPagenum',item)
        }
    }
}
</script>

<style>
#recordContent {
    flex: 1;
    height: 100%;
    padding: 16px 0 0 20px;
}

.recordContent {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 10px 0 0 10px;
    margin-bottom: 15px;
}
</style>